import { createAsyncTypes } from 'utils/ActionCreator'

export const DATA_REQUEST_ASYNC = createAsyncTypes('DATA_REQUEST', 'Mailboxes/Management')
export const STATUSES_TOGGLE_ASYNC = createAsyncTypes(
  'STATUSES_TOGGLE_ASYNC',
  'Mailboxes/Management'
)
export const FETCH_PROFILES_SUGGESTIONS_ASYNC = createAsyncTypes(
  'FETCH_PROFILES_SUGGESTIONS',
  'Mailboxes/Management'
)
export const CREATE_COMPLIANCE_REPORT_ASYNC = createAsyncTypes(
  'CREATE_COMPLIANCE_REPORT',
  'Mailboxes/Management'
)

export const FETCH_MANAGEMENT_TAGS_ASYNC = createAsyncTypes(
  'FETCH_MANAGEMENT_TAGS_ASYNC',
  'Mailboxes/Management'
)

export const ADD_ASYNC = createAsyncTypes('ADD_ASYNC', 'Mailboxes/Management')
export const ACTIVATE_SELECT_ALL = 'Mailboxes/Management/ACTIVATE_SELECT_ALL'
export const SORT_PROPERTY_CHANGE = 'Mailboxes/Management/SORT_PROPERTY_CHANGE'
export const TYPE_FILTER_CHANGE = 'Mailboxes/Management/TYPE_FILTER_CHANGE'
export const PROTECTED_FILTER_CHANGE = 'Mailboxes/Management/PROTECTED_FILTER_CHANGE'
export const TAGS_FILTER_CHANGE = 'Mailboxes/Management/TAGS_FILTER_CHANGE'
export const SEGMENTS_FILTER_CHANGE = 'Mailboxes/Management/SEGMENTS_FILTER_CHANGE'
export const RISK_LEVELS_FILTER_CHANGE = 'Mailboxes/Management/RISK_LEVELS_FILTER_CHANGE'
export const PAGINATE_CHANGE = 'Mailboxes/Management/PAGINATE_CHANGE'
export const SEARCH_CHANGE = 'Mailboxes/Management/SEARCH_CHANGE'
export const SEARCH_RESET = 'Mailboxes/Management/SEARCH_RESET'
export const NAME_FOR_HISTORY_STORE = 'mailboxesManagement'
export const CHANGE_COMPLIANCE_REPORT_DATA = 'mailboxesManagement/CHANGE_COMPLIANCE_REPORT_DATA'
export const CLEAR_COMPLIANCE_REPORT_DATA = 'mailboxesManagement/CLEAR_COMPLIANCE_REPORT_DATA'

export const SET_MANAGEMENT_TAGS_PAGE = 'MailboxesManagement/SET_MANAGEMENT_TAGS_PAGE'
export const SET_MANAGEMENT_TAGS_SEARCH = 'MailboxesManagement/SET_MANAGEMENT_TAGS_SEARCH'

export const TIME_PERIOD_VALUES = {
  LAST_YEAR: 0,
  THIS_YEAR: 1,
  LAST_3_MONTHS: 2,
  LAST_6_MONTHS: 3,
  CUSTOM: 4,
}

export const REPORT_TYPE_VALUES = {
  SIMULATION_AND_TRAINING: 1,
}

export const REPORT_TYPE_OPTIONS = [
  {
    label: 'Simulation & training',
    value: REPORT_TYPE_VALUES.SIMULATION_AND_TRAINING,
  },
]

export const TIME_PERIOD_OPTIONS = [
  {
    label: 'Last year',
    value: TIME_PERIOD_VALUES.LAST_YEAR,
  },
  {
    label: 'This year',
    value: TIME_PERIOD_VALUES.THIS_YEAR,
  },
  {
    label: 'Last 3 months',
    value: TIME_PERIOD_VALUES.LAST_3_MONTHS,
  },
  {
    label: 'Last 6 months',
    value: TIME_PERIOD_VALUES.LAST_6_MONTHS,
  },
  {
    label: 'Custom',
    value: TIME_PERIOD_VALUES.CUSTOM,
  },
]

export const EXPORT_FORMAT_VALUES = {
  CSV: 1,
  PDF: 2,
}

export const EXPORT_FORMAT_OPTIONS = [
  {
    label: 'CSV',
    value: EXPORT_FORMAT_VALUES.CSV,
  },
  {
    label: 'PDF',
    value: EXPORT_FORMAT_VALUES.PDF,
  },
]
